var React = require('react');

function CheckmarkInDisplayInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#D2D1D1","d":"M.793 4.335H65.5v45.048H.793z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M4.646 8.287h57.001v34.675H4.646z","key":1}),React.createElement("path",{"fill":"#3F64AF","d":"m22.413 25.18-2.075 2.371 8.256 8.299L47.9 18.067l-2.469-2.47-16.837 15.806z","key":2}),React.createElement("path",{"fill":"#D2D1D1","d":"M29.244 49.384h7.805v8.595h-7.805zm-7.206 8.595h22.217v3.951H22.038z","key":3})]);
}

CheckmarkInDisplayInline.defaultProps = {"width":"66","height":"66","viewBox":"0 3 66 66"};

module.exports = CheckmarkInDisplayInline;

CheckmarkInDisplayInline.default = CheckmarkInDisplayInline;
